import { api } from "@/lib/api";

import type {
  CashReport,
  CashSource,
  SalePaymentMethod,
} from "@artisancode/api-types";

export interface CashReportParams {
  date_from?: string;
  date_to?: string;
  source?: CashSource;
  method?: SalePaymentMethod;
  rider_id?: string;
  workspace_id?: string;
}

export const cashReportService = {
  get: (params?: CashReportParams) =>
    api.get<CashReport>(
      "/cash-report",
      params as Record<string, string | number | boolean | undefined>,
    ),
};
